/**
 * Restore Shopify accelerated checkout (Shop Pay / PayPal / Apple Pay / Google Pay)
 * after BSS B2B injects CSS that hides .shopify-payment-button__*.
 * B2B accounts keep BSS behaviour via body.fe-is-b2b.
 */
(function () {
  'use strict';

  if (document.body && document.body.classList.contains('fe-is-b2b')) return;

  function initPaymentButtons() {
    try {
      if (window.Shopify && Shopify.PaymentButton && typeof Shopify.PaymentButton.init === 'function') {
        Shopify.PaymentButton.init();
      }
    } catch (e) {}
  }

  function revealNativeButtons() {
    document.querySelectorAll(
      '.shopify-payment-button, .shopify-payment-button__button, .shopify-payment-button__more-options, shopify-accelerated-checkout, shopify-accelerated-checkout-cart'
    ).forEach(function (el) {
      if (el.classList.contains('shopify-payment-button__skeleton')) return;
      el.style.setProperty('display', '', 'important');
      el.style.setProperty('visibility', 'visible', 'important');
      el.style.setProperty('opacity', '1', 'important');
      if (el.getAttribute('aria-hidden') === 'true' && el.classList.contains('shopify-payment-button__button')) {
        // Leave Shopify to manage disabled/skeleton until wallets mount.
      }
    });

    document.querySelectorAll('.bss-b2b-btn-buyitnow').forEach(function (el) {
      el.style.setProperty('display', 'none', 'important');
    });
  }

  function run() {
    revealNativeButtons();
    initPaymentButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  window.addEventListener('load', function () {
    run();
    window.setTimeout(run, 400);
    window.setTimeout(run, 1200);
  });

  // Cart drawer / section re-renders
  document.addEventListener('cart:refresh', run);
  document.addEventListener('theme:cart:change', run);
})();
